export const encodeObject = (obj) => {
    return btoa(JSON.stringify(obj));
};

export const decodeString = (str) => {
    return JSON.parse(atob(str));
};
